import { useState, useEffect, useRef } from "react";
import { getSportsList } from "../api/studentsApi";
import GlobalQuickJump from "../../../global/GlobalQuickJump";
import "../../../global/directory/globalDirectory.css";
import StudentRegistrationMetricsSection from "../components/studentRegistration/sections/StudentRegistrationMetricsSection";
import StudentRegistrationFormSection from "../components/studentRegistration/sections/StudentRegistrationFormSection";
import StudentRegistrationDirectorySection from "../components/studentRegistration/sections/StudentRegistrationDirectorySection";
import { filterActiveMasterRows } from "../../memberships/utils/masterLookupUtils";
import "../styles/studentRegistration.css";

const QUICK_JUMP_ITEMS = [
  { key: "stats", label: "Stats Overview", targetId: "sr-stats" },
  { key: "registration", label: "Registration Form", targetId: "sr-registration" },
  { key: "list", label: "Students List", targetId: "sr-list" },
];

export default function StudentRegistrationsPage() {
  const [sports, setSports] = useState([]);
  const [error, setError] = useState(null);
  const [activeQuickJump, setActiveQuickJump] = useState(null);
  const [dashRefresh, setDashRefresh] = useState(0);
  const [editingStudentId, setEditingStudentId] = useState(null);
  const registrationSectionRef = useRef(null);

  useEffect(() => {
    fetchSportsList();
  }, []);

  const fetchSportsList = async () => {
    try {
      const result = await getSportsList();
      if (result.success) {
        setSports(filterActiveMasterRows(result.sports));
      }
    } catch (err) {
      setError(err.message);
    }
  };

  const handleEditStudent = (id) => {
    setEditingStudentId(id);
    setActiveQuickJump("registration");
    requestAnimationFrame(() => {
      registrationSectionRef.current?.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    });
  };

  const handleStudentSaved = () => {
    setDashRefresh((n) => n + 1);
    setEditingStudentId(null);
  };

  return (
    <div className="student-reg-shell">
      <header className="student-reg-hero">
        <div className="student-reg-hero__text">
          <p className="student-reg-hero__eyebrow">Student Management</p>
          <h2 className="student-reg-hero__title">Member Registration</h2>
          <p className="student-reg-hero__sub">
            Register new students and track their statistics. Sports master is maintained under
            Admin → Tournaments Control.
          </p>
        </div>
      </header>

      {error ? (
        <p className="student-reg-hero__sub" style={{ color: "var(--color-danger, #b91c1c)" }}>
          {error}
        </p>
      ) : null}

      <div className="student-reg-layout">
        <div className="student-reg-layout__main">
          <StudentRegistrationMetricsSection refreshKey={dashRefresh} />
          <StudentRegistrationFormSection
            sports={sports}
            editingStudentId={editingStudentId}
            onCancelEdit={() => setEditingStudentId(null)}
            onRegistered={handleStudentSaved}
            sectionRef={registrationSectionRef}
          />
          <StudentRegistrationDirectorySection
            refreshKey={dashRefresh}
            sports={sports}
            onEditStudent={handleEditStudent}
          />
        </div>

        <GlobalQuickJump
          asideAriaLabel="Quick actions"
          items={QUICK_JUMP_ITEMS}
          activeKey={activeQuickJump}
          onActiveChange={setActiveQuickJump}
        />
      </div>
    </div>
  );
}
